export default {
  downloadFormat: {
    CM10: 'CM10',
    pdf: 'PDF File',
    copy: 'Digitally signed copy of the original',
    ubl: 'UBL 1.0',
    facturae_3_2: 'Facturae 3.2',
    facturae_3_2_1: 'Facturae 3.2.1',
    facturae_3_2_2: 'Facturae 3.2.2',
    owner: 'Proprietary format',
    pdfocr: 'PDF for OCR'
  },
  acceptedBills: 'The invoices were accepted successfully',
  rejectedBills: 'The invoices were rejected successfully',
  unrejectedBills: 'The invoices were unrejected successfully',
  cancelledBills: 'The invoice cancellation requests were made successfully',
  acceptedCancel: 'The invoices cancellation were accepted successfully',
  rejectCancel: 'The invoices cancellation were rejected successfully',
  sentBills: 'The invoices were sent successfully',
  deletedBills: 'The invoices were deleted successfully',
  financingSuccessed: 'Your financing request has started correctly.'
}
